module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4b9e70e5ad6ef623649d528723adb033.png";